import {
  select,
  put,
  fork,
  call,
  takeEvery,
  takeLatest,
  all,
} from 'redux-saga/effects';
import app from '../../app';
import {
  getProvinceName,
  getCityName,
  getCountyName,
  getTownName,
  loadProvinceList,
  loadCityList,
  loadCountyList,
  // loadTownList,
} from '../../utils/address';
import {
  loadAddressListCompletion,
  changeDefAddressCompletion,
  deleteAddressCompletion,
  editAddressCompletion,
  saveOrderDetailAddressCompletion,
  catchError,
} from '../../actions';

export function* watchLoadAddressList() {
  yield takeLatest('LOAD_ADDRESS_LIST', function*() {
    const options = {
      url: '/api/user/address/list',
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadAddressListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchChangeDefAddress() {
  yield takeEvery('CHANGE_DEF_ADDRESS', function*({ addressId }) {
    const options = {
      url: '/api/user/address/setDef',
      method: 'POST',
      data: { aid: addressId },
    };
    const result = yield call(app.httpFetch, options);
    yield put(changeDefAddressCompletion(addressId, result.error));
  });
}

export function* watchDeleteAddress() {
  yield takeEvery('DELETE_ADDRESS', function*({ addressId }) {
    const options = {
      url: '/api/user/address/del',
      method: 'POST',
      data: { aid: addressId },
    };
    const result = yield call(app.httpFetch, options);
    yield put(deleteAddressCompletion(addressId, result.error));
  });
}

export function* watchEditAddress() {
  yield takeEvery('EDIT_ADDRESS', function*({ addressId }) {
    const {
      name,
      mobile,
      detail,
      provinceId,
      cityId,
      countyId,
      townId,
    } = yield select(state => state.mall.address.edit.input);

    let error;
    let submitMobile = mobile.trim();
    if (!name) {
      error = new Error('请填写收货人姓名');
    } else if (!submitMobile) {
      error = new Error('请填写收货人手机号码');
    } else if (!detail) {
      error = new Error('请填写详细地址');
    }

    if (!error) {
      if (!provinceId) {
        const provinceResult = yield call(loadProvinceList);
        error = provinceResult.error;

        if (!error && provinceResult.list && provinceResult.list.length > 0) {
          error = new Error('请选择省份');
        }
      }
    }
    if (!error) {
      if (!cityId && provinceId) {
        const cityResult = yield call(loadCityList, provinceId);
        error = cityResult.error;

        if (!error && cityResult.list && cityResult.list.length > 0) {
          error = new Error('请选择城市');
        }
      }
    }
    if (!error) {
      if (!countyId && cityId) {
        const countyResult = yield call(loadCountyList, cityId);
        error = countyResult.error;

        if (!error && countyResult.list && countyResult.list.length > 0) {
          error = new Error('请选择地区');
        }
      }
    }
    // if (!error) {
    //   if (!townId && countyId) {
    //     const townResult = yield call(loadTownList, countyId);
    //     error = townResult.error;

    //     if (!error && townResult.list && townResult.list.length > 0) {
    //       error = new Error('请选择街道');
    //     }
    //   }
    // }

    if (error) {
      yield put(catchError(error));
      app.dispatch(editAddressCompletion(addressId, error));
      return;
    }

    const options = {
      url: addressId ? '/api/user/address/update' : '/api/user/address/add',
      method: 'POST',
      data: {
        aid: addressId,
        name,
        mobile: submitMobile,
        detail,
        provinceId,
        cityId,
        countyId,
        townId,
        provinceName: getProvinceName(provinceId),
        cityName: getCityName(cityId),
        countyName: getCountyName(countyId),
        townName: getTownName(townId),
      },
    };
    const result = yield call(app.httpFetch, options);
    app.dispatch(editAddressCompletion(addressId, result.error, result.data));
  });
}

export function* watchSaveOrderDetailAddress() {
  yield takeLatest('SAVE_ORDER_DETAIL_ADDRESS', function* ({ orderId }) {
    const { addrId } = yield select(state => state.mall.address.orderDetailAddr.input);

    const options = {
      url: '/api/order/update/address',
      method: 'POST',
      data: {
        orderId,
        aid: addrId,
      }
    }

    const result = yield call(app.httpFetch, options);
    yield put(saveOrderDetailAddressCompletion(result.error));
  })
}

export default function* addressSaga() {
  yield all([
    fork(watchLoadAddressList),
    fork(watchChangeDefAddress),
    fork(watchDeleteAddress),
    fork(watchEditAddress),
    fork(watchSaveOrderDetailAddress)
  ]);
}
